export default "__VITE_ASSET__B3_Tyg3F__"